/**
 * API service for Models (for companies)
 */

const API_BASE_URL = 'https://universal-ai-agent-backend.diypa571.workers.dev'

export interface AIModel {
  id: number
  name: string
  provider: string
  model_identifier: string
  description?: string
  is_active: boolean
}

class ModelsService {
  private async getAuthHeaders(): Promise<HeadersInit> {
    const token = localStorage.getItem('token')
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token || ''}`
    }
  }

  async getAvailableModels(): Promise<AIModel[]> {
    try {
      const headers = await this.getAuthHeaders()
      const response = await fetch(`${API_BASE_URL}/api/models`, {
        headers
      })

      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.message || 'Failed to fetch available models')
      }

      const data = await response.json()
      return data.data || []
    } catch (error) {
      console.error('Get available models error:', error)
      throw error
    }
  }
}

export const modelsService = new ModelsService()

